export function formatVideoTime(seconds: number) {
  const value = Math.max(0, Math.floor(seconds))
  const hours = Math.floor(value / 3600)
  return `${hours ? `${hours}:` : ""}${String(Math.floor(value / 60) % 60).padStart(2, "0")}:${String(value % 60).padStart(2, "0")}`
}

export function activeSegmentIndex(segments: Array<{ start: number; end: number }>, seconds: number) {
  let left = 0
  let right = segments.length - 1
  let result = -1
  while (left <= right) {
    const middle = Math.floor((left + right) / 2)
    if (segments[middle]!.start <= seconds) {
      result = middle
      left = middle + 1
    } else right = middle - 1
  }
  return result >= 0 && seconds < segments[result]!.end ? result : -1
}
